import { render, staticRenderFns } from "./AccountInspectionEvents.vue?vue&type=template&id=271a61d0&"
import script from "./AccountInspectionEvents.vue?vue&type=script&lang=js&"
export * from "./AccountInspectionEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports